import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from '../brand/Logo';
import { Seo } from '../Seo';

/** Split layout shared by sign in, link verification and onboarding. */
export function AuthShell({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <>
      <Seo title={title} description="Sign in to the Cavalla client portal." path="/portal/login" noIndex data-id="element-925" data-mp="zfc4eenfu7t0" />
      <div className="grid min-h-screen w-full bg-charcoal lg:grid-cols-[1fr_1.1fr]" data-id="element-926" data-mp="14eoncob6uuqb">
        <div className="surface-dark flex flex-col justify-between px-6 py-8 sm:px-10 lg:px-14 lg:py-12" data-id="element-927" data-mp="19cgrcgp3y7av">
          <Link to="/" aria-label="Cavalla, back to the website" className="inline-block" data-id="element-928" data-mp="1ebtdt0c2hccx">
            <Logo variant="reversed" data-id="element-929" data-mp="1ie6j5nmwj896" />
          </Link>
          <div className="my-12 hidden lg:block" data-id="element-930" data-mp="1icvcng22nmed">
            <p className="max-w-md font-display text-[34px] font-light leading-tight text-white" data-id="element-931" data-mp="3g47slqjbe0p4">
              One login for every engagement you hold with us.
            </p>
            <p className="mt-5 max-w-md text-[16px] leading-relaxed text-white/72" data-id="element-932" data-mp="1emnfl0drvgcu">
              Consulting work with Cavalla Solution and delivery tracking on Cavalla Gov sit in one place, with the
              files, messages and invoices for each.
            </p>
          </div>
          <p className="hidden text-small text-white/50 lg:block" data-id="element-933" data-mp="14uhkviw4ykty">Access is by invitation from your organisation or from us.</p>
        </div>
        <main id="main" className="flex items-center justify-center px-6 py-12 sm:px-10" data-id="element-934" data-mp="1xlrkpy270pz8">
          <div className="w-full max-w-md" data-id="element-935" data-mp="1slvc1lijwadc">{children}</div>
        </main>
      </div>
    </>;
}